module.exports = __webpack_public_path__ + "static/img/fail.5ddb2a4c.svg";